import { render } from "./SelectCustUserModal.vue?vue&type=template&id=36775804&scoped=true"
import script from "./SelectCustUserModal.vue?vue&type=script&lang=js"
export * from "./SelectCustUserModal.vue?vue&type=script&lang=js"

import "./SelectCustUserModal.vue?vue&type=style&index=0&id=36775804&lang=scss&scoped=true"

import exportComponent from "C:\\projects\\balkan-app-links\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36775804"]])

export default __exports__